var map = {
	"./Corn_Starch.jpg": 6591,
	"./Maize_Starch.png": 4565,
	"./Maize_Starch2.jpg": 7211,
	"./Native_Potato_Starch.png": 3582,
	"./Potato_Starch.png": 7562,
	"./Potato_Starchs.jpeg": 2284,
	"./Sago_Starch.png": 5763,
	"./Sago_Starch_1.jpeg": 5000,
	"./Sago_Starch_2.png": 2244,
	"./Sago_Starch_3.png": 5485,
	"./Tapiaco_Starch.jpeg": 2201,
	"./Tapiaco_Thippu.jpg": 7831,
	"./Trade_Needs.jpg": 2539,
	"./globe.png": 4256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6772;